export type SupportedTokenField = 'decimals' | 'symbol' | 'name' | 'image' /* | 'totalSupply' */;
